/**
 * Mirrors jump_spinner in Elixir
 */

import React from 'react'

export function JumpSpinner() {
  return (
    <div className="relative animate-spin w-4 h-4" data-qa="frontend-loading-spinner">
      <svg className="w-full h-full -rotate-90" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="16" fill="none" className="stroke-current icon-tertiary" strokeWidth="2"></circle>
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          className="stroke-current text-primary dark:text-link"
          strokeWidth="2"
          strokeDasharray="100"
          strokeDashoffset="75"
          strokeLinecap="round"
        ></circle>
      </svg>
    </div>
  )
}
